import { graphql, useFragment } from 'react-relay';

import { useGetPriceAmountByType } from '../pricingGuidanceHelpers';
import { useShowPricingGuidance } from './useShowPricingGuidance';

import { type useGetEstimatedValueRange_item$key } from './__generated__/useGetEstimatedValueRange_item.graphql';

const itemFragment = graphql`
    fragment useGetEstimatedValueRange_item on Item {
        ...pricingGuidanceHelpers_item
        ...useShowPricingGuidance_item
    }
`;

export const useGetEstimatedValueRange = ({
    item: itemRef,
    currency,
}: {
    item: useGetEstimatedValueRange_item$key;
    currency: string;
}): { rangeMin: number; rangeMax: number } => {
    const item = useFragment(itemFragment, itemRef);

    const rangeMin = useGetPriceAmountByType({ item, currency, type: 'MIN' });
    const rangeMax = useGetPriceAmountByType({ item, currency, type: 'MAX' });

    return { rangeMin, rangeMax };
};

export const useIsBelowEstimatedValueMaxRange = ({
    item: itemRef,
    currency,
}: {
    item: useGetEstimatedValueRange_item$key | null;
    currency: string;
}): boolean => {
    const item = useFragment(itemFragment, itemRef) || null;

    const showPricingGuidance = useShowPricingGuidance({ item, currency });

    const itemPrice = useGetPriceAmountByType({ item, currency, type: 'ITEM_PRICE' });
    const rangeMax = useGetPriceAmountByType({ item, currency, type: 'MAX' });

    return showPricingGuidance && itemPrice <= rangeMax;
};
